import * as Yup from 'yup'
import { websiteValidationCheckMessage } from '../../../common/utils/messagesContants'

export const ListingUrlInputValidationSchema = Yup.object().shape({
  listingUrl: Yup.string()
    .required('Listing url cannot be empty.')
    .url(websiteValidationCheckMessage),
})
